import { Stack, Box } from '@mui/material';
import { Card, CardMedia, CardContent } from '../common/Card/index.js';
import { PLACEHOLDER_IMAGES } from '../../constants/images';
import { EXTERNAL_LINKS } from '../../constants/links';

const FeaturesSection = ({ onVideoOpen }) => {
  return (
    <Stack spacing={2}>
      {/* Video and NFT Cards Row */}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        <Box sx={{ width: { xs: '100%', md: '50%' } }}>
          <Card
            height={280}
            onClick={onVideoOpen}
          >
            <CardMedia image={PLACEHOLDER_IMAGES.features.video} />
            <CardContent 
              title="THIS IS PARADISE TYCOON"
              subtitle="Watch the Video!"
              titleImage={PLACEHOLDER_IMAGES.features.videoTitle}
              isSpecialTitle
            />
          </Card>
        </Box>

        <Box sx={{ width: { xs: '100%', md: '50%' } }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            {[
              {
                image: PLACEHOLDER_IMAGES.features.paradisePass,
                titleImage: PLACEHOLDER_IMAGES.features.paradisePassTitle,
                subtitle: "Explore the NFTs",
                link: EXTERNAL_LINKS.paradisePass
              },
              {
                image: PLACEHOLDER_IMAGES.features.paradiseTools,
                titleImage: PLACEHOLDER_IMAGES.features.paradiseToolsTitle,
                subtitle: "Explore the NFTs",
                link: EXTERNAL_LINKS.paradiseTools
              }
            ].map((item, index) => (
              <Box key={index} sx={{ width: { xs: '100%', sm: '50%' } }}>
                <Card
                  height={280}
                  href={item.link}
                >
                  <CardMedia image={item.image} />
                  <CardContent 
                    titleImage={item.titleImage}
                    subtitle={item.subtitle}
                  />
                </Card>
              </Box>
            ))}
          </Stack>
        </Box>
      </Stack>

      {/* Creator Program and Roadmap/About Row */}
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        <Box sx={{ width: { xs: '100%', md: '50%' } }}>
          <Card
            height={650}
            href={EXTERNAL_LINKS.creator}
          >
            <CardMedia image={PLACEHOLDER_IMAGES.features.creator} />
            <CardContent 
              titleImage={PLACEHOLDER_IMAGES.features.creatorTitle}
              subtitle="Learn how to create your own events in Paradise Tycoon"
              isSpecialTitle
              alignTop
            />
          </Card>
        </Box>

        <Box sx={{ width: { xs: '100%', md: '50%' } }}>
          <Stack spacing={2}>
            {[
              {
                image: PLACEHOLDER_IMAGES.features.roadmap,
                titleImage: PLACEHOLDER_IMAGES.features.roadmapTitle,
                subtitle: "Discover the exciting new features and expansions coming soon!",
                link: EXTERNAL_LINKS.roadmap
              },
              {
                image: PLACEHOLDER_IMAGES.features.about,
                titleImage: PLACEHOLDER_IMAGES.features.aboutTitle,
                subtitle: "Meet the Team!",
                link: EXTERNAL_LINKS.team
              }
            ].map((item, index) => (
              <Box key={index}>
                <Card
                  height={315}
                  href={item.link}
                >
                  <CardMedia image={item.image} />
                  <CardContent 
                    titleImage={item.titleImage}
                    subtitle={item.subtitle}
                  />
                </Card>
              </Box>
            ))}
          </Stack>
        </Box>
      </Stack>
    </Stack>
  );
};

export default FeaturesSection; 